import React, {useState} from 'react';
import {FormikHelpers} from 'formik';

import {Button, Form} from '@components';

import * as handlers from './handlers';
import {Props} from './types';

import './index.scss';

const Create: React.FC<Props> = props => {
  const [isModal, setIsModal] = useState(false);

  const initialValues = {
    firstName: props.users.detail.firstName,
    lastName: props.users.detail.lastName,
    lastKana: props.users.detail.lastKana,
    firstKana: props.users.detail.firstKana,
    email: props.users.detail.email,
    phoneNumber: props.users.detail.phoneNumber,
    prefecture: null,
    authLevel: null,
    teamId: props.me.teamId,
    password: '',
    confirmPassword: '',
    position: '',
    organization: '',
    gender: null,
    birthyear: null,
    birthmonth: null,
    birthday: null,
  };

  return (
    <div className="a__admin-create">
      <div className="b__title">
        <Button.GoBack history={props.history} />
        ユーザー追加
      </div>
      <div className="w__create">
        <Form.User
          initialValues={initialValues}
          me={props.me}
          users={props.users}
          submitText="登録する"
          handleSubmit={(value: any, formikHelpers: FormikHelpers<any>) => {
            handlers.create(
              value,
              formikHelpers,
              props.actions,
              props.history,
              props.me,
              setIsModal
            );
          }}
          create
          isPassword
          isCreateMailModal={isModal}
          handleCloseModal={setIsModal}
          history={props.history}
        />
      </div>
    </div>
  );
};

export default Create;
